module.exports = __webpack_public_path__ + "acd5f627.jpg";